import moment from 'moment';

const isSameOrAfter = (dateA, dateB, granularity) => {
  return moment(dateA).isSameOrAfter(dateB, granularity);
};

export default isSameOrAfter;
